export default [
  {
    type: 'text',
    title: '🚀 Umfangreiches Update für eine bessere Nutzererfahrung',
    text: [
      'Das SAV-Tool 2.0 bringt zahlreiche Verbesserungen in der Fallverwaltung, neue Funktionen für Felder und Berichte, sowie ein optimierter Fall-Verlauf. <strong>Sie können nun Fälle zu jederzeit wiederöffnen.</strong> Zudem gibt es Erweiterungen bei der elektronischen Signatur, bessere Exporte und viele weitere Detailverbesserungen.',
      'Die wichtigsten Neuerungen umfassen eine überarbeitete Versionierung von Fällen, erweiterte Überprüfungsfunktionen und ein neues System für ICD/DMS-Diagnosen. Darüber hinaus wurden verschiedene Layout- und Performance-Optimierungen vorgenommen, um die Benutzerfreundlichkeit weiter zu steigern.',
    ],
  },
  {
    type: 'text',
    title: null,
    mirrored: false,
    text: [
      '<strong>Mit der neuen Version wurden neue Felddaten eingepflegt.</strong> Bestehende Fälle wurden als Version 1 markiert, während neue Fälle automatisch als Version 2 erfasst werden. Es wurde die Möglichkeit geschaffen, Fälle von Version 1 auf Version 2 zu migrieren.',
      'Ein weiterer Fokus lag auf der Optimierung der Überprüfungsfunktion. Ab sofort können Änderungskommentare für jedes geänderte Feld hinterlegt und Überprüfungen zwischengespeichert werden. Dies ermöglicht eine bessere Nachvollziehbarkeit der Änderungen.',
    ],
  },
  { type: 'separator' },
  {
    type: 'list',
    listtype: 'added',
    items: [
      'Neue Fallstruktur mit Versionierung und Migrationsoptionen',
      'Überarbeitete ICD/DMS-Erfassung mit neuen Eingabefeldern',
      'Elektronische Signaturen im Benutzerprofil mit Unterschrifts-Upload',
      'Überarbeitete Exports für Word/PDF mit optimierter Dateibenennung',
      'Erweiterte Filter- und Suchfunktion in Dropdown-Listen',
    ],
  },
  {
    type: 'list',
    listtype: 'changed',
    items: [
      'Verbesserte Benutzerführung mit verständlicheren Prozessabschlüssen',
      'Anpassungen an der Fall-Wiedereröffnung und Archivierung',
      'Überarbeitung des PDF und Word-Layouts',
      'Standardwerte und Validierungen für verschiedene Felder angepasst',
    ],
  },
  {
    type: 'list',
    listtype: 'removed',
    items: [
      'Entfernung redundanter Felder für mehr Übersichtlichkeit',
      'Anonymisierungsprozess wurde entfernt',
    ],
  },
  {
    type: 'list',
    listtype: 'fixes',
    items: [
      'Auto-Fokus für SMS-Code-Eingabe optimiert',
      'Konsistenz und Validierung in Dropdown-Werten verbessert',
      'Fehler bei der Anzeige von Diagnosen in Berichten behoben',
    ],
  },
];
